import { render, staticRenderFns } from "./VerItemOdontologia.vue?vue&type=template&id=3be605c2&scoped=true"
import script from "./VerItemOdontologia.vue?vue&type=script&lang=js"
export * from "./VerItemOdontologia.vue?vue&type=script&lang=js"
import style0 from "./VerItemOdontologia.vue?vue&type=style&index=0&id=3be605c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be605c2",
  null
  
)

export default component.exports